import React, {FC} from "react"
import styled, {css} from "styled-components"

import {Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {WellnessMediaType} from "@irati/types"
import mainTheme from "@irati/ui/src/global/theme"

export const DetailPillContainer = styled(Flex)`
  ${({theme}) => css`
    position: relative;
    background-color: ${theme.colors.greys.dark};
    padding: ${theme.spacing.half} ${theme.spacing.one};
    border-radius: ${theme.border.radius.medium};
    text-align: center;
  `}
`

interface Props {
  text: string
  type?: WellnessMediaType
}

const DetailsPill: FC<Props> = ({text, type}) => (
  <DetailPillContainer marginRight={2} alignItems="center">
    {type && (
      <Icon
        icon={
          type === WellnessMediaType.SingleVideo
            ? IconTypes.video
            : type === WellnessMediaType.Article
              ? IconTypes.article
              : IconTypes.audio
        }
        color={mainTheme.colors.greys.white}
        marginRight={type === WellnessMediaType.Article ? 0 : 0.5}
      />
    )}
    {type && type !== WellnessMediaType.Article && <Label color={mainTheme.colors.greys.white}>{text}</Label>}
  </DetailPillContainer>
)

export default DetailsPill
